import bb from 'blingblingjs';
import {show, hide} from './page-overlay'; 
import {breakpoints} from './config';
const state = {
    isOpen: false,
    isOpenClick : false
}

const trigger = bb('.js-el__mini-cart-trigger');
const clickTrigger = bb('.js-el__mini-cart-click-trigger');
const cart   = bb('.js-el__mini-cart')[0]
const pageWrapper = bb('.js-el__page-wrapper')[0]


function open(){

    if(window.innerWidth > Number(breakpoints.m)) {
        state.isOpen = true;
        update();
    }
   
}

function close(){
    state.isOpen = false;
    update();
}

function closeAll(e){
    if(e.target == pageWrapper) {
        state.isOpen = false;
        state.isOpenClick = false;
        update();
    }
}
function toggleClick(e){
    e && e.stopPropagation();
    if(state.isOpenClick){
        state.isOpen = false; 
        state.isOpenClick = false;
    } else {
        state.isOpenClick = true;
    }
    update();
}



trigger.on('mouseenter', open);
trigger.on('mouseleave', close);
clickTrigger.on('click', toggleClick)
pageWrapper.on('click', closeAll)


// Open the cart when something is added to it
window.addEventListener("addedToCart", function(){
    if (typeof currentProduct.selectedVariant.available != "undefined" && !currentProduct.selectedVariant.available) { return }
    toggleClick()
}, false); 

function update(){
    if(state.isOpen){
        cart.classList.add('--is-open');
    } else {
        cart.classList.remove('--is-open');
    }

    if(state.isOpenClick){
        cart.classList.add('--is-open-click'); 
    } else {
        cart.classList.remove('--is-open-click');
    }

    if(state.isOpen || state.isOpenClick) {
        show()
        refreshMiniCart()
    } else {
        hide()
    }
}
